import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconQuickReply",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, _, p, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--quick-reply"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Quick Reply",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M10 8.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 1 0-1h5A1.5 1.5 0 0 1 11 3.5v5A1.5 1.5 0 0 1 9.5 10H3.707l-1.853 1.854A.5.5 0 0 1 1 11.5V9a.5.5 0 1 1 1 0v1.293l1.147-1.146.076-.063A.5.5 0 0 1 3.5 9h6a.5.5 0 0 0 .5-.5ZM2.071 1.743a.5.5 0 0 1 .858.514L1.883 4H3a.501.501 0 0 1 .429.757l-1.5 2.5a.5.5 0 0 1-.858-.514L2.117 5H1a.5.5 0 0 1-.429-.757l1.5-2.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ o(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=quick-reply.js.map
